import React from 'react';

type Props = {
    children?: React.ReactNode | React.ReactNode[],
    width?: number | string,
    maxWidth?: number | string,
};

export const WidthItem = ({children, width, maxWidth}: Props) => {
    return <div style={{width, maxWidth}}>{children}</div>;
};
